import { useEffect, useMemo, useState } from 'react';

import { Text } from '@thefarmersfront/kitchen';

import { Table } from '~/components/common';

import { useStableCallback } from '~/hooks/common';
import { useGetShippersDeliveryOperations } from '~/hooks/delivery-agency/api';
import { type TypeDeliveryOperationInfoRow, getVenderConfirmDeliveryOperationInfoColumnDefs } from '~/utils';

import type { TypeGetShippersDeliveryOperationsResponse } from '~/types/delivery-agency.types';

import styles from './VenderConfirmDeliveryOperationInfoSection.module.scss';

/**
 * [화주사 정보 관리 > 화주사 정보] 배송운영 정보 영역 (3PL 배송대행 권한 시 노출)
 */
const VenderConfirmDeliveryOperationInfoSection = () => {
  const { columnDefs } = useMemo(() => getVenderConfirmDeliveryOperationInfoColumnDefs(), []);

  const { requestDeliveryOperations } = useGetShippersDeliveryOperations();
  const stableRequestDeliveryOperations = useStableCallback(requestDeliveryOperations);

  const [inboundHubs, setInboundHubs] = useState<TypeGetShippersDeliveryOperationsResponse['data']['inboundHubs']>([]);

  useEffect(() => {
    stableRequestDeliveryOperations({
      onSuccess: (data) => {
        setInboundHubs(data.inboundHubs);
      },
    });
  }, [stableRequestDeliveryOperations]);

  const tableData: TypeDeliveryOperationInfoRow[] = inboundHubs.map((hub) => ({
    inboundHub: hub.description,
    inboundSchedule:
      hub.inboundSchedules.length > 0
        ? hub.inboundSchedules
            .map((schedule) => `${schedule.from.split(':')[0]}~${schedule.to.split(':')[0]}시`)
            .join(', ')
        : '-',
  }));

  return (
    <div className={styles['section-container']}>
      <Text className={styles['section-title']} size="xxlarge" weight="bold" element="p">
        배송운영 정보
      </Text>
      <div className={styles['section-table-wrapper']}>
        <Table data={tableData} columns={columnDefs} />
      </div>
    </div>
  );
};

export default VenderConfirmDeliveryOperationInfoSection;
